import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-86e06d4c"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "window"
};
var _hoisted_2 = {
  class: "flex flex_between"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "返回", -1);
});

var _hoisted_4 = {
  class: "content_box"
};
var _hoisted_5 = {
  class: "box"
};
var _hoisted_6 = {
  class: "flex"
};
var _hoisted_7 = {
  class: "img"
};
var _hoisted_8 = {
  class: "item_contnet"
};
var _hoisted_9 = {
  class: "special flex_between"
};
var _hoisted_10 = {
  key: 0,
  class: "state to_start"
};
var _hoisted_11 = {
  key: 1,
  class: "state to_processed"
};
var _hoisted_12 = {
  key: 2,
  class: "state resolved"
};
var _hoisted_13 = {
  key: 3,
  class: "state not_solved"
};
var _hoisted_14 = {
  key: 4,
  class: "state timeout"
};
var _hoisted_15 = {
  class: "special"
};
var _hoisted_16 = {
  class: "left"
};
var _hoisted_17 = {
  class: "special"
};
var _hoisted_18 = {
  class: "left"
};
var _hoisted_19 = {
  class: "flex"
};

var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "简介 :", -1);
});

var _hoisted_21 = {
  style: {
    "word-break": "break-all"
  }
};
var _hoisted_22 = {
  class: "box"
};
var _hoisted_23 = {
  class: "special"
};

var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "开始时间 :", -1);
});

var _hoisted_25 = {
  class: "special"
};

var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "结束时间 :", -1);
});

var _hoisted_27 = {
  class: "special"
};

var _hoisted_28 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "紧急联系人 :", -1);
});

var _hoisted_29 = {
  class: "special"
};

var _hoisted_30 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "联系人关系 :", -1);
});

var _hoisted_31 = {
  class: "special",
  style: {
    "margin-bottom": "0"
  }
};

var _hoisted_32 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "紧急联系人电话 :", -1);
});

var _hoisted_33 = {
  key: 0,
  class: "box"
};

var _hoisted_34 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "third_box_label"
  }, [/*#__PURE__*/_createElementVNode("label", {
    class: "tally"
  }), /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "跟进记录")], -1);
});

var _hoisted_35 = {
  class: "progress_box"
};
var _hoisted_36 = {
  class: "icon"
};
var _hoisted_37 = {
  key: 2,
  class: "line"
};
var _hoisted_38 = {
  class: "process_content"
};
var _hoisted_39 = {
  class: "title"
};
var _hoisted_40 = {
  class: "time"
};
var _hoisted_41 = {
  key: 0,
  class: "imgbox"
};
var _hoisted_42 = {
  key: 0,
  class: "footer flex flex_justify_center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");

  var _component_ArrowRight = _resolveComponent("ArrowRight");

  var _component_el_icon = _resolveComponent("el-icon");

  var _component_el_image = _resolveComponent("el-image");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_Head, {
    title: "志愿服务"
  }), _createElementVNode("div", {
    class: "back",
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    function () {
      return _ctx.back && _ctx.back.apply(_ctx, arguments);
    })
  }, [_hoisted_3, _createVNode(_component_el_icon, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_ArrowRight, {
        color: "#c62423"
      })];
    }),
    _: 1
  })])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_ctx.data.userIcon ? (_openBlock(), _createBlock(_component_el_image, {
    key: 0,
    style: {
      "width": "100px",
      "height": "100px",
      "border-radius": "10px"
    },
    src: _ctx.baseUrl + _ctx.data.userIcon,
    fit: "fit"
  }, null, 8, ["src"])) : (_openBlock(), _createBlock(_component_el_image, {
    key: 1,
    style: {
      "width": "100px",
      "height": "100px",
      "border-radius": "10px"
    },
    src: require('@/assets/img/headIcon.jpg'),
    fit: "fit"
  }, null, 8, ["src"]))]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", null, _toDisplayString(_ctx.data.userName), 1), _ctx.data.helpState == 0 && _ctx.data.status == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 待开始 ")) : _createCommentVNode("", true), _ctx.data.helpState == 0 && _ctx.data.status == 4 ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 待处理 ")) : _createCommentVNode("", true), _ctx.data.status == 5 && _ctx.data.helpState == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_12, " 已解决 ")) : _createCommentVNode("", true), _ctx.data.status == 5 && _ctx.data.helpState == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 未解决 ")) : _createCommentVNode("", true), _ctx.data.status == 5 && _ctx.data.helpState == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_14, " 超时 ")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_image, {
    style: {
      "margin-right": "8px",
      "height": "16px",
      "width": "16px",
      "vertical-align": "middle"
    },
    src: require('@/assets/img/helpInPairs/phone.png')
  }, null, 8, ["src"]), _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.data.phone), 1)]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_el_image, {
    style: {
      "margin-right": "8px",
      "height": "22px",
      "width": "16px",
      "vertical-align": "middle"
    },
    src: require('@/assets/img/helpInPairs/address.png'),
    fit: "fill"
  }, null, 8, ["src"]), _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.data.address), 1)])])]), _createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.data.content), 1)])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_hoisted_24, _createElementVNode("span", null, _toDisplayString(_ctx.data.startTime), 1)]), _createElementVNode("div", _hoisted_25, [_hoisted_26, _createElementVNode("span", null, _toDisplayString(_ctx.data.endTime), 1)]), _createElementVNode("div", _hoisted_27, [_hoisted_28, _createElementVNode("span", null, _toDisplayString(_ctx.data.contants), 1)]), _createElementVNode("div", _hoisted_29, [_hoisted_30, _createElementVNode("span", null, _toDisplayString(_ctx.data.contantRelationship), 1)]), _createElementVNode("div", _hoisted_31, [_hoisted_32, _createElementVNode("span", null, _toDisplayString(_ctx.data.contantPhone), 1)])]), _ctx.data.messages && _ctx.data.messages.length != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_hoisted_34, _createElementVNode("div", _hoisted_35, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.messages, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "process_item"
    }, [_createElementVNode("div", _hoisted_36, [_ctx.data.status == 5 && index == 0 ? (_openBlock(), _createBlock(_component_el_image, {
      key: 0,
      class: "spot",
      src: require('@/assets/img/helpInPairs/complete.png'),
      fit: "fill"
    }, null, 8, ["src"])) : (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "spot",
      style: _normalizeStyle({
        background: index == 0 && _ctx.data.status == 4 ? '#f5a426' : '#afb1bb'
      })
    }, null, 4)), index != _ctx.data.messages.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_37)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", {
      class: _normalizeClass(["progress_top", {
        record_lable_color: index == 0 && _ctx.data.status == 4
      }])
    }, [_createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.data.responsibilityName), 1), _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.transformationTime(item.createTime)), 1)], 2), _createElementVNode("div", {
      class: "details",
      style: _normalizeStyle({
        paddingBottom: index != _ctx.data.messages.length - 1 ? '39rpx' : 0
      })
    }, [_createElementVNode("span", null, _toDisplayString(item.helpingRecords), 1), item.helpPhoto ? (_openBlock(), _createElementBlock("div", _hoisted_41, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.helpPhoto.split(','), function (img, index) {
      return _openBlock(), _createBlock(_component_el_image, {
        key: index,
        class: "image",
        src: _ctx.baseUrl + img,
        "preview-src-list": _ctx.previewImgList(item.helpPhoto),
        "initial-index": index,
        fit: "cover",
        "z-index": "99999"
      }, null, 8, ["src", "preview-src-list", "initial-index"]);
    }), 128))])) : _createCommentVNode("", true)], 4)])]);
  }), 128))])])) : _createCommentVNode("", true)]), _ctx.data.status != 5 ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_ctx.data.responsibilityId == _ctx.userId ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["btn btn_fill", {
      disable: _ctx.data.status == 2
    }]),
    onClick: _cache[1] || (_cache[1] = //@ts-ignore
    function () {
      return _ctx.toProgress && _ctx.toProgress.apply(_ctx, arguments);
    })
  }, " 添加进度 ", 2)) : _createCommentVNode("", true), _ctx.data.userId == _ctx.userId ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(["btn btn_hollow", {
      disable: !_ctx.data.messages || _ctx.data.messages.length == 0
    }]),
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.operation(2);
    })
  }, " 不满意 ", 2)) : _createCommentVNode("", true), _ctx.data.userId == _ctx.userId ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: _normalizeClass(["btn btn_fill", {
      disable: !_ctx.data.messages || _ctx.data.messages.length == 0
    }]),
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return _ctx.operation(1);
    })
  }, " 满意 ", 2)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
}